/**
 * The `ui.render_error` event for a React render crash (components/ErrorBoundary.jsx):
 * the scrubbed message and the top frames of the JS stack and the component stack.
 */
import { frameLines, scrubFreeText } from "./sanitize.js";

const MESSAGE_MAX = 300;
const FRAMES_MAX = 5;

const frames = (stack) => frameLines(stack, FRAMES_MAX);

/** `ui.render_error` for `error` and React's `info` (`componentStack`). */
export function renderErrorEvent(error, info) {
  return {
    event: "ui.render_error",
    message: scrubFreeText(error?.message ?? String(error), MESSAGE_MAX),
    frames: frames(error?.stack),
    component_frames: frames(info?.componentStack),
  };
}
